import { Repeat } from '@griply/assets';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from 'shared/components/ui/icon';
import {
  PopupMenu,
  PopupMenuList,
  PopupMenuListItem,
  PopupMenuToggle,
} from 'shared/components/ui/popup-menu';

export type CompletedContextMenuProps = {
  referenceElement?: React.RefObject<HTMLButtonElement>;
  onClose: () => void;
  showHabits: boolean;
  onToggleShowHabits: () => void;
};

export const CompletedContextMenu: React.FC<CompletedContextMenuProps> = ({
  referenceElement,
  onClose,
  showHabits,
  onToggleShowHabits,
}) => {
  const { t } = useTranslation();

  return (
    <PopupMenu
      referenceElement={referenceElement}
      position="bottom-end"
      onOutside={onClose}
    >
      <PopupMenuList hasBottomBorder>
        <PopupMenuListItem>
          <PopupMenuToggle
            start={<Icon icon={Repeat} />}
            label={t('completed.header.show-habits')}
            onChange={onToggleShowHabits}
            checked={showHabits}
          />
        </PopupMenuListItem>
      </PopupMenuList>
    </PopupMenu>
  );
};
